import Component from '../../../../../pages/vip/features/fulfillment-information/fulfillment-information';

export default Component;
